if (!customElements.get('product-content-layout')) {
  customElements.define(
    'product-content-layout',
    class ProductContentLayout extends HTMLElement {
      constructor() {
        super();
        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.updateLayout = this.updateLayout.bind(this);
        this.updateStickyState = this.updateStickyState.bind(this);
      }

      connectedCallback() {
        if (this.dataset.stickyInfo !== 'true') return;

        this.summary = this.querySelector('.product__summary-wrapper');
        this.media = this.querySelector(':scope > .product__media-wrapper');
        this.purchase = this.querySelector('.product__purchase-details-wrapper');
        if (!this.summary || !this.media || !this.purchase) return;

        if (this.desktopQuery.addEventListener) {
          this.desktopQuery.addEventListener('change', this.updateLayout);
        } else {
          this.desktopQuery.addListener(this.updateLayout);
        }
        window.addEventListener('resize', this.updateStickyState);
        this.updateLayout();
      }

      disconnectedCallback() {
        if (this.desktopQuery.addEventListener) {
          this.desktopQuery.removeEventListener('change', this.updateLayout);
        } else {
          this.desktopQuery.removeListener(this.updateLayout);
        }
        window.removeEventListener('resize', this.updateStickyState);
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }

      updateLayout() {
        if (this.desktopQuery.matches) {
          this.groupDesktopInfo();
        } else {
          this.restoreMobileOrder();
        }
      }

      groupDesktopInfo() {
        if (!this.desktopColumn) {
          this.desktopColumn = document.createElement('div');
          this.desktopColumn.className = 'product__desktop-info-column grid__item';
        }

        this.insertBefore(this.desktopColumn, this.media.nextSibling);
        if (this.desktopColumn.moveBefore) {
          this.desktopColumn.moveBefore(this.summary, null);
          this.desktopColumn.moveBefore(this.purchase, null);
        } else {
          this.desktopColumn.append(this.summary, this.purchase);
        }
        this.classList.add('product--sticky-column-ready');

        if (!this.resizeObserver && typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.updateStickyState);
          this.resizeObserver.observe(this.desktopColumn);
        }
        this.updateStickyState();
      }

      updateStickyState() {
        if (!this.desktopColumn || !this.desktopQuery.matches) return;

        this.desktopColumn.classList.add('product__column-sticky');
        const stickyTop = Math.max(0, parseFloat(getComputedStyle(this.desktopColumn).top) || 0);
        const availableHeight = Math.max(0, window.innerHeight - stickyTop - 24);
        const bounds = this.desktopColumn.getBoundingClientRect();
        const columnHeight = Math.ceil(bounds.height || this.desktopColumn.scrollHeight);
        this.desktopColumn.classList.toggle('product__column-sticky', columnHeight <= availableHeight);
      }

      restoreMobileOrder() {
        if (!this.desktopColumn) return;

        this.desktopColumn.classList.remove('product__column-sticky');

        const submedia = this.querySelector(':scope > .product__media-submedia-wrapper');
        if (this.moveBefore) {
          this.moveBefore(this.summary, this.media);
          this.moveBefore(this.purchase, submedia || null);
        } else {
          this.insertBefore(this.summary, this.media);
          this.insertBefore(this.purchase, submedia || null);
        }
        this.desktopColumn.remove();
        this.classList.remove('product--sticky-column-ready');
      }
    }
  );
}
